import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  ModalBody,
  ListboxMultiselect,
  ModalHeaderWithActions,
} from "@evertrue/et-components";
import {
  Form,
  JourneysFormField,
  JourneysRow,
  JourneysLabel,
  JourneysInput,
} from "scripts/style/components/form";
import { editJourneyGroup } from "apps/journeys/utils/api-requests/journeys-requests.js";

const JourneyGroupModal = ({ isOpen, onClose, group = {} }) => {
  const [journeyGroupName, setJourneyGroupName] = useState("");
  const [users, setUsers] = useState([]);

  //populate the data
  useEffect(() => {
    const getAndSetData = () => {
      if (group.name !== "") {
        setJourneyGroupName(group.name);
      }
    };
    getAndSetData();
  }, [group]);

  const handleSubmit = () => {
    const payload = {
      ...group,
    };
    payload.name = journeyGroupName;
    editJourneyGroup(payload, payload.id);
    onClose();
  };

  const handleChange = (val) => {
    setUsers(val);
  };
  return (
    <Modal isOpen={isOpen} closeModal={onClose}>
      <ModalHeaderWithActions
        title={"Edit Group"}
        submitLabel={"Edit Group"}
        closeModal={onClose}
        onSubmit={handleSubmit}
      />
      <ModalBody scrollable={false}>
        <Form>
          <JourneysRow>
            <div>
              <JourneysFormField>
                <JourneysLabel htmlFor="display-name">Group Name</JourneysLabel>
                <JourneysInput
                  type="text"
                  onChange={({ target: { value } }) =>
                    setJourneyGroupName(value)
                  }
                  name="Group name"
                  value={journeyGroupName}
                />
              </JourneysFormField>
            </div>

            <JourneysFormField>
              <JourneysLabel htmlFor="field-type">User</JourneysLabel>
              <ListboxMultiselect
                emptyValue="Select Users"
                label="Select User"
                options={users}
                onChange={handleChange}
              />
            </JourneysFormField>
          </JourneysRow>
        </Form>
      </ModalBody>
    </Modal>
  );
};

JourneyGroupModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  group: PropTypes.object,
};

JourneyGroupModal.defaultProps = {
  group: {},
};

export default JourneyGroupModal;
